import axios from 'axios'
// import store from '@/store'
import context from '../main.js'
import { clearToken } from '../utils/tools'

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  // 获取http请求中的请求配置
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url] // deleted 的用法？ES6class的规范？

    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)

      // 清除token，重新登录
      if (res.data.ret === 406) {
        clearToken()
        context.$vs.notify({
            title:'提示',
            text: '登录超时，请重新登录',
            color:'warning',
            iconPack: 'feather',
            icon:'icon-alert-circle'
        })
      } else if (res.data.ret !== 200) {
        context.$vs.notify({
            title:'错误',
            text: res.data.msg,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'
        })
        console.log('错误')
      } else if (res.data.data.err_code !== 0) {
        context.$vs.notify({
            title:'错误',
            text: res.data.data.err_msg,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'
        })
      } 
      // 统一返回接口的数据
      return res.data
      
    }, error => {
      this.destroy(url)
      let errorInfo = error.response
      if (!errorInfo) {
        const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
        errorInfo = {
          statusText,
          status,
          request: { responseURL: config.url }
        }
      }
      // addErrorLog(errorInfo)
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
